export const enum VALID_SPLITPAY_TYPES {
    SWIGGYPAY = "SWIGGYPAY",
    FLIPKARTSUPERCOIN = "FLIPKARTSUPERCOIN",
    INTERMILES = "INTERMILES",
    YES_BANK = "YES_BANK",
}

export const SPLITPAY_METHOD_STORAGE_KEY = "splitpay_method";
export const DEFAULT_SPLITPAY_METHOD = "default";
